<template>
  <div class="star-wrap">
    <!-- <div class="star-title">
      {{ starContent.title }}
    </div> -->
    <div class="belcome-button">
      <el-button type="primary" @click="become" v-if="!signed">
        参与时长激励</el-button
      >
      <el-button type="primary" disabled v-else> 已参与时长激励</el-button>
    </div>
    <div class="content" v-html="starContent.content"></div>
    <div class="become-dialog">
      <el-dialog
        title="温馨提示"
        width="600px"
        :visible.sync="take_time_incentive"
      >
        <div class="dialog-content">
          {{ messageText }}
        </div>
        <el-button
          type="primary"
          @click="participate"
          v-if="
            this.developerInfo.state !== 0 || this.developerInfo.state !== 3
          "
        >
          确认参与</el-button
        >
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  fetchStarContent,
  takeStarPlan,
  fetchStarProduct,
} from '@/api/activity';
import * as Sentry from '@sentry/vue';
import { mapState } from 'vuex';
// loadScript('//mnweb.mini1.cn/activity/H5Community/m/eruda.js');
// function loadScript(url) {
//   let scriptEl = document.createElement('script');
//   document.body.appendChild(scriptEl);
//   scriptEl.type = 'text/javascript';
//   scriptEl.src = url;
// }
export default {
  data() {
    return {
      starContent: {},
      take_time_incentive: false,
      monthValue: '',
      messageText:
        '您将报名加入星启计划-时长激励计划。报名成功后，在后续每个激励周期（自然月）内，只要该账号下的地图达到激励游戏人数的条件（每月地图累积游戏人数达到星启计划要求条件），则会自动进入星启计划-时长激励计划地图质量评定流程，质量评定通过后即可获得激励（质量评定会有邮件通知，请注意查收）。',
      signed: false,
    };
  },
  mounted() {
    this.monthValue = new Date();
    this.init();
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  methods: {
    init() {
      this.getStarData();
      this.getSign();
    },
    become() {
      this.take_time_incentive = true;
    },
    async getSign() {
      let year = this.monthValue.getFullYear();
      let month =
        this.monthValue.getMonth() + 1 < 10
          ? '0' + (this.monthValue.getMonth() + 1)
          : this.monthValue.getMonth() + 1;
      let month_value = year + '' + month;
      let data = {
        page: 1,
        page_size: 30,
        month: month_value,
      };
      const res = await fetchStarProduct(data);
      if (res.code !== 218) this.signed = true;
      //表示已报名星启计划
      else this.signed = false; //表示未报名星启计划
      if (this.developerInfo.state == 0 || this.developerInfo.state == 3) {
        this.messageText =
          '请先认证成为开发者，认证成为开发者后即可参与时长激励报名，享受收益分成！';
      } else if (this.signed) {
        this.messageText =
          '您的账号已成功参加星启计划-时长激励计划。在每个激励周期（自然月）内，只要该账号下的地图达到激励游戏人数的条件（每月地图累积游戏人数达到星启计划要求条件），则会自动进入星启计划-时长激励计划地图质量评定流程，质量评定通过后即可获得激励（质量评定会有邮件通知，请注意查收）。';
      } else {
        this.messageText =
          '您将报名加入星启计划-时长激励计划。报名成功后，在后续每个激励周期（自然月）内，只要该账号下的地图达到激励游戏人数的条件（每月地图累积游戏人数达到星启计划要求条件），则会自动进入星启计划-时长激励计划地图质量评定流程，质量评定通过后即可获得激励（质量评定会有邮件通知，请注意查收）。';
      }
    },
    //报名参与星启计划
    async participate() {
      const uin = this.userInfo.uin;
      Sentry.configureScope(function (scope) {
        console.log('uin:', uin);
        scope.setTag('xingqi', 'center/star');
        scope.setUser({
          email: uin,
        });
      });
      try {
        const res = await takeStarPlan();
        if (res.data.code === 0) {
          this.$message.success('参与成功');
          this.take_time_incentive = false;
          this.getSign();
        } else {
          this.$message.error(res.data.msg);
          this.take_time_incentive = false;
          this.getSign();
        }
      } catch (e) {
        console.log(e);
        console.log('时长激励参与失败');
      }
    },
    async getStarData() {
      const res = await fetchStarContent({});
      this.starContent = res.data.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.star-wrap {
  margin-top: 30px;
  // ::v-deep section:nth-child(2) {
  //   section {
  //     background: #f5f5f5;
  //     section {
  //       background: none;
  //     }
  //   }
  // }
  // ::v-deep section:first-child {
  //   background: none;
  // }
  .belcome-button {
    //float: right;
  }
  .el-button--primary {
    //back
    background-color: #409eff;
    border-color: #409eff;
    font-size: 16px;
  }
  .el-button--primary.is-disabled {
    //back
    background-color: #c0c4cc;
    border-color: #c0c4cc;
    font-size: 16px;
  }
  .content {
    padding-top: 40px;
  }
  .belcome-button {
    .el-button {
      margin-top: 10px;
      margin-left: 500px;
      float: right;
    }
  }
  ::v-deep.el-dialog__header {
    text-align: center;
  }
  ::v-deep.el-dialog__body {
    .dialog-content {
      font-size: 16px;
    }
    .el-button {
      margin-top: 20px;
      margin-left: 450px;
    }
  }
}
</style>
